import { fromJS } from 'immutable';

import { GLOBAL_SEARCH_BASE_API } from '../constants/endpoints';
import { addPriceToBaseProduct } from '../util/mapToObject';

export const globalSearchApi = query => {
  const method = 'GET';
  const headers = new window.Headers();
  const mode = 'cors';

  const url = `${GLOBAL_SEARCH_BASE_API}?query=${query}`;

  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');

  const options = {
    headers,
    method,
    mode
  };

  return window
    .fetch(url, options)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return 'error';
    })
    .then(data => {
      if (data && data.products && data.products.hits && data.products.hits.length) {
        return {
          ...data,
          products: {
            hits: data.products.hits.map(productHit => ({
              ...productHit,
              item: addPriceToBaseProduct(fromJS(productHit.item))
            }))
          }
        };
      }
      return data;
    })
    .catch(error => {
      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/api/globalSearchApi.js